"use client";
import { Suspense } from "react";
import GoogleAnalytics from "./GoogleAnalytics";

const GoogleAnalyticsWrapper = () => {
  return (
    <Suspense fallback={<div>Loading...</div>}>
      <GoogleAnalytics />
    </Suspense>
  );
};

export default GoogleAnalyticsWrapper;
